const relatedProductsCl = {
  wrapper: "related-products-wrapper-js",
  cardBtn: "card-product-small-button-js",
  popup: "related-products-popup-js",
  popupOverlay: "related-products-popup-overlay-js",
  popupCloseBtn: "related-products-popup-close-js",
  quantityInputWrapper: "related-products-popup-quantity-input-wrapper-js",
  quantityInput: "related-products-popup-quantity-input-js",
  quantityPlusBtn: "related-products-popup-quantity-plus-js",
  quantityMinusBtn: "related-products-popup-quantity-minus-js",
  basketBtn: "related-products-popup-basket-btn-js",
  radio: "related-products-popup-radio-js",
  product: "related-products-popup-product-js",
  priceTag: "related-products-popup-price-js",
};

const switchPriceTag = function (chosenVariant) {
  const priceTags = chosenVariant
    .closest("." + relatedProductsCl.product)
    .querySelectorAll("." + relatedProductsCl.priceTag);
  priceTags.forEach((tag) => {
    const tagMoneyEl = tag.querySelector(".money") || tag;
    const previousPrice = tag.getAttribute("data-total-price");

    if (tag.hasAttribute("original-price")) {
      tag.setAttribute(
        "data-total-price",
        chosenVariant.getAttribute("data-variant-original-price"),
      );
      tag.setAttribute(
        "data-product-price",
        chosenVariant.getAttribute("data-variant-original-price"),
      );
      tag.setAttribute(
        "data-product-price-currency",
        chosenVariant.getAttribute("data-variant-original-price-currency"),
      );
      tagMoneyEl.textContent = tagMoneyEl.textContent.replace(
        previousPrice,
        tag.getAttribute("data-product-price"),
      );
      return;
    }

    tag.setAttribute(
      "data-total-price",
      chosenVariant.getAttribute("data-variant-price"),
    );
    tag.setAttribute(
      "data-product-price",
      chosenVariant.getAttribute("data-variant-price"),
    );
    tag.setAttribute(
      "data-product-price-currency",
      chosenVariant.getAttribute("data-variant-price-currency"),
    );

    tagMoneyEl.textContent = tagMoneyEl.textContent.replace(
      previousPrice,
      tag.getAttribute("data-product-price"))
  })
};

const enableQuantityAndBasket = function (radio) {
  const productWrapper = radio.closest("." + relatedProductsCl.product);
  // productWrapper.querySelector('.' + relatedProductsCl.basketBtn).removeAttribute('disabled');
  // quantityWrapper.removeAttribute('inactive');

  const quantityWrapper = productWrapper.querySelector(
    "." + relatedProductsCl.quantityInputWrapper,
  );
  const quantityInput = quantityWrapper.querySelector("input");
  quantityInput.setAttribute(
    "data-chosen-variant-inventory",
    radio.getAttribute("data-variant-inventory"),
  );
  quantityInput.setAttribute(
    "max",
    radio.getAttribute("data-variant-inventory"),
  );
  quantityInput.value = 1;
  quantityInput.setAttribute("value", 1);
};

const updateProductQuantity = function (quantityInput, action = "plus") {
  const currentQuantity = +quantityInput.value;
  let newQuantity;

  if (action === "plus") {
    newQuantity = currentQuantity + 1;
    quantityInput.value = newQuantity;
    quantityInput.setAttribute("value", newQuantity);

    calculatePriceTag(quantityInput.closest("." + relatedProductsCl.product));
  } else if (action === "minus" && currentQuantity > 1) {
    newQuantity = currentQuantity - 1;
    quantityInput.value = newQuantity;
    quantityInput.setAttribute("value", newQuantity);

    calculatePriceTag(
      quantityInput.closest("." + relatedProductsCl.product),
      "minus",
    );
  } else if (action === "manual") {
    newQuantity = currentQuantity;
    quantityInput.value = newQuantity;
    quantityInput.setAttribute("value", newQuantity);

    calculatePriceTag(
      quantityInput.closest("." + relatedProductsCl.product),
      "manual",
      newQuantity,
    );
  }
};

const calculatePriceTag = function (product, action = "plus", quantity = 1) {
  const priceTags = product.querySelectorAll("." + relatedProductsCl.priceTag);

  const renderNewPrice = function (priceTag, previousTotalStr, newTotal) {
    const tagMoneyEl = priceTag.querySelector(".money") || priceTag;
    priceTag.setAttribute("data-total-price", newTotal.toFixed(2));
    tagMoneyEl.textContent = tagMoneyEl.textContent.replace(
      previousTotalStr,
      newTotal.toFixed(2),
    );
  };

  priceTags.forEach((tag) => {
    const previousTotalStr = tag.getAttribute("data-total-price");
    const previousTotal = +tag.getAttribute("data-total-price");
    const productPrice = +tag.getAttribute("data-product-price");
    let newTotal;

    if (action === "plus") {
      newTotal = previousTotal + productPrice * quantity;
      renderNewPrice(tag, previousTotalStr, newTotal);
    } else if (action === "minus") {
      newTotal = previousTotal - productPrice * quantity;
      renderNewPrice(tag, previousTotalStr, newTotal);
    } else if (action === "manual") {
      newTotal = productPrice * quantity;
      renderNewPrice(tag, previousTotalStr, newTotal);
    }
  });
};

/* GENERAL FUNCTIONS - END */

const showRelatedProductsPopup = function (popup) {
  popup.setAttribute("active", "");
};

const hideRelatedProductsPopup = function (popup) {
  popup.removeAttribute("active");
};

const addRelatedProductsEvents = function (relatedProductsPopup) {
  const relatedProductsWrapper = document.querySelector(
    "." + relatedProductsCl.wrapper,
  );

  relatedProductsWrapper.addEventListener("click", (e) => {
    if (e.target.classList.contains(relatedProductsCl.cardBtn)) {
      showRelatedProductsPopup(relatedProductsPopup);
    }
  });

  relatedProductsPopup.addEventListener("click", (e) => {
    if (!relatedProductsPopup.hasAttribute("active")) return;

    if (
      e.target.closest("button." + relatedProductsCl.popupCloseBtn) ||
      e.target.classList.contains(relatedProductsCl.popupOverlay)
    ) {
      hideRelatedProductsPopup(relatedProductsPopup);
    }

    if (e.target.closest("." + relatedProductsCl.radio)) {
      const radioInput = e.target
        .closest("." + relatedProductsCl.radio)
        .querySelector("input");
      if (radioInput.hasAttribute("out-of-stock")) return;

      enableQuantityAndBasket(radioInput);
      switchPriceTag(radioInput);
    }

    if (e.target.closest("." + relatedProductsCl.quantityPlusBtn)) {
      updateProductQuantity(
        e.target
          .closest("." + relatedProductsCl.quantityInputWrapper)
          .querySelector("input"),
      );
    }

    if (e.target.closest("." + relatedProductsCl.quantityMinusBtn)) {
      updateProductQuantity(
        e.target
          .closest("." + relatedProductsCl.quantityInputWrapper)
          .querySelector("input"),
        "minus",
      );
    }
  });

  relatedProductsPopup
    .querySelectorAll("." + relatedProductsCl.quantityInputWrapper)
    .forEach((input) => {
      input.querySelector("input").addEventListener("keyup", (e) => {
        if (e.target.value < 1) {
          e.target.value = 1;
        }
        updateProductQuantity(e.target, "manual");
      });
    });
};

export default function () {
  const relatedProductsPopup = document.querySelector(
    "." + relatedProductsCl.popup,
  );
  if (!relatedProductsPopup) return;

  addRelatedProductsEvents(relatedProductsPopup);
}
